import axios from 'axios'
import { Markup } from '@/dto/deliveries/Markup'

const MarkupService = {
  load(deliveryId: number): Promise<Markup[]> {
    return axios
      .get(`/admin/deliveries/${deliveryId}/extra-charge`)
      .then(response => response.data.markups)
  },

  save(markup: Markup, deliveryId: number): Promise<Markup> {
    return axios
      .put(`/admin/deliveries/${deliveryId}/extra-charge`, markup)
      .then(response => response.data.markup)
  },
}

export default MarkupService
